export default {
  // setTab(state, index) {
  //   state.tabIndex = index
  // }
}
